import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromoBlock } from 'www-cms';
import { ButtonComponent } from 'ui-elements/button';
import { RouterLink } from '@angular/router';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-promo-block',
  imports: [
    CommonModule,
    ButtonComponent,
    ImageWithLoaderComponent,
    RouterLink,
    DirectusDirective,
  ],
  templateUrl: './promo-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoBlockComponent extends BaseBuildingBlockComponent {
  constructor() {
    super();
  }
  @Input() promoBlockData?: PromoBlock;

  override getBgClass(): LastItemBgClass {
    return 'bg-white';
  }
}
